// extracted by mini-css-extract-plugin
module.exports = {"User":"UserButton_User__gZQ5e","Avatar":"UserButton_Avatar__dbEWZ","ForHireBadge":"UserButton_ForHireBadge__SgeHi"};